// useLakeelValidation.ts (Vue2 + @vue/composition-api)
import Vue from 'vue';
import { getCurrentInstance, reactive, nextTick } from '@vue/composition-api';
import { LakeelValidation } from 'lib-lakeel-validation';

const HOST = process.env.VUE_APP_LAKEEL_SYNERGY_LOGIC_HOSTNAME;

export function useLakeelValidation(store, formModel, formComponent) {
  const vm = getCurrentInstance()?.proxy;
  const validationService = new LakeelValidation(HOST);
  // ライブラリが this[field] に書き込む前提。Vue2なので形を先に定義しておく
  vm.validResult = reactive({ isError: false, error: [] });

  // 個別（el-form-item の validator 用）: Promise 返却に統一（callback 併用は非推奨）
  async function onEventValidation(rule, value) {
    await nextTick();
    await validationService.lakeelValidAll.call(
      vm,
      {
        formName: 'form',
        auto: true,
        field: 'validResult',
        lslHostName: HOST,
        relationMsgDisplayType: 'first',
      },
      rule.field,
    );
    const prop = rule.fullField || rule.field; // 例: "itemsTableData.0.unitPrice"
    // サーバ側の validPropertyName を form の prop に合わせて正規化
    const pickMyErrors = (vm.validResult.error || []).filter(e => {
      const raw = e.validPropertyName || '';
      // 例: "widgetTarget.tableData.44.twNewValue" 的な接頭辞を剥がす
      const normalized = raw
        .replace(/^widgetTarget\./, '')
        .replace(/^form\./, '');
      // ここは環境に合わせて調整（完全一致・endsWith 等）
      return normalized.endsWith(prop);
    });
    if (pickMyErrors.length) {
      const m =
        pickMyErrors[0]?.validMessage?.message || '入力に誤りがあります';
      throw new Error(m);
    }
    return true;
  }

  // フォーム全体
  async function validationCheck() {
    await nextTick();
    await validationService.lakeelValidAll.call(vm, {
      formName: 'form',
      auto: true,
      field: 'validResult',
      lslHostName: HOST,
      relationMsgDisplayType: 'first',
    });
    // 呼び出し側で使いやすい戻り値
    return {
      ok: !vm.validResult.isError,
      result: vm.validResult, // リアクティブ参照
    };
  }
  return {
    validationService,
    validResult: vm.validResult, // 画面で監視できる
    onEventValidation,
    validationCheck,
  };
}
